import React, { useState, useCallback, useRef } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '600px',
  height: '400px'
};

const center = {
  lat: 10.4762746,
  lng: -66.9420512
};

function Map({ location, setter, style, readonly }) {
  const [markerPosition, setMarkerPosition] = useState(location || center);
  const [address, setAddress] = useState('');
  const mapRef = useRef(null);

  const onMapClick = useCallback((event) => {
    if (readonly) {
      return;
    } else {
      const newLat = event.latLng.lat();
      const newLng = event.latLng.lng();
      setter({
        lat: newLat,
        lng: newLng
      });

      setMarkerPosition({
        lat: newLat,
        lng: newLng
      });

      // Reverse geocode to get address from coordinates
      geocodeLatLng({ lat: newLat, lng: newLng });
    }
  }, [readonly, setter]);

  const onLoad = useCallback(function callback(map) {
    mapRef.current = map;
  }, []);

  const onUnmount = useCallback(function callback(map) {
    mapRef.current = null;
  }, []);

  const handleAddressChange = (event) => {
    setAddress(event.target.value);
  };

  const handleSearchAddress = () => {
    if (address.trim() === '') return;
    geocodeAddress(address);
  };

  const geocodeAddress = (addressToGeocode) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ 'address': addressToGeocode }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const newLat = results[0].geometry.location.lat();
        const newLng = results[0].geometry.location.lng();
        setter({
          lat: newLat,
          lng: newLng
        });
        setMarkerPosition({
          lat: newLat,
          lng: newLng
        });
        if (mapRef.current) {
          mapRef.current.panTo({ lat: newLat, lng: newLng });
          mapRef.current.setZoom(15); // Zoom in after searching for an address
        }
        setAddress(results[0].formatted_address); // Update input with formatted address
      } else {
        alert('No se pudo encontrar la dirección: ' + status);
      }
    });
  };

  const geocodeLatLng = (latlng) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ 'location': latlng }, (results, status) => {
      if (status === 'OK' && results[0]) {
        setAddress(results[0].formatted_address);
      } else {
        console.error('No se pudo obtener la dirección para estas coordenadas: ' + status);
      }
    });
  };

  // Effect to update address when location prop changes
  React.useEffect(() => {
    if (location && (location.lat !== markerPosition.lat || location.lng !== markerPosition.lng)) {
      setMarkerPosition(location);
      geocodeLatLng(location);
    }
  }, [location]);

  return (
    <LoadScript googleMapsApiKey="AIzaSyD2bpJfBkXDdESJw-sfs-oZOHuLeaQL8qI">
      <div style={{ marginBottom: '10px' }}>
        <input
          type="text"
          placeholder="Buscar dirección..."
          value={address}
          onChange={handleAddressChange}
          style={{ width: 'calc(100% - 70px)', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleSearchAddress();
            }
          }}
        />
        <button
          onClick={handleSearchAddress}
          style={{ padding: '8px 10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', marginLeft: '5px' }}
        >
          Buscar
        </button>
      </div>
      <GoogleMap
        mapContainerStyle={style || containerStyle}
        center={markerPosition} // Center the map on the marker position
        zoom={10}
        onLoad={onLoad}
        onUnmount={onUnmount}
        onClick={onMapClick}
      >
        <Marker position={markerPosition} />
      </GoogleMap>
    </LoadScript>
  );
}

export default React.memo(Map);